module.exports = __webpack_public_path__ + "static/img/statusCorrectLisa.7f63d3ad.gif";